// Links shared across the IDX page's sections and dialogs.

/** The iHomefinder app's Wix App Market listing, as linked from Settings › Integrations. */
export const WIX_APP_MARKET_URL = "https://www.wix.com/app-market/ihomefinder-real-estate";

export const CONTACT_SUPPORT_URL = "https://www.ihomefinder.com/resources/support/#contact";
